import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { motion } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, anchors: true, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div id="top" className="App bg-[#F4F3EF] text-[#0A0A0A] antialiased">
        <motion.div
          data-testid="page-load-overlay"
          aria-hidden="true"
          className="fixed inset-0 z-[100] bg-[#0A0A0A] pointer-events-none"
          initial={{ y: 0 }}
          animate={{ y: "-100%" }}
          transition={{ duration: 1.1, delay: 0.15, ease: [0.76, 0, 0.24, 1] }}
        />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <main>
                  <Hero />
                  <Marquee />
                  <About />
                  <Manifesto />
                  <Services />
                  <Portfolio />
                  <Testimonials />
                  <Contact />
                </main>
                <Footer />
              </>
            }
          />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <Toaster position="bottom-center" />
      </div>
    </BrowserRouter>
  );
}

export default App;
